import { getLeFEOrigin } from '@utils/util';

export const TrialManagerLeFE = () => (
    <iframe className="admin-iframe" title="问卷管理" src={`${getLeFEOrigin()}/#/app/unifinder/trial`} />
);
